import { render, staticRenderFns } from "./FileItem.vue?vue&type=template&id=7dca4033&scoped=true"
import script from "./FileItem.vue?vue&type=script&lang=js"
export * from "./FileItem.vue?vue&type=script&lang=js"
import style0 from "./FileItem.vue?vue&type=style&index=0&id=7dca4033&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca4033",
  null
  
)

export default component.exports